import { Statistic } from 'antd';
import styled from 'styled-components';

export const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  padding-left: 10px;
`;

export const TrendWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const StyledStatistic = styled(Statistic)`
  line-height: 1.25;
  height: 40px;

  .ant-statistic-title {
    margin-bottom: 0;
    color: #939393;
  }

  .ant-statistic-content,
  .ant-statistic-content-value {
    font-size: 14px;
    font-weight: 500;
    line-height: 0.5;
  }

  .ant-statistic-content-suffix {
    font-size: 16px;
  }
`;

export const VerticalDivider = styled.div`
  border: 1px solid #eee;
  position: absolute;
  left: 50%;
  height: 95%;
`;

export const HorizontalDivider = styled.div`
  border: 1px solid #eee;
  position: absolute;
  top: 50%;
  width: 98%;
`;

export const CardWrapper = styled.div`
  position: relative;
  height: 100px;
  overflow: hidden;
  padding-left: 3px;
  min-width: 150px;
  cursor: pointer;

  &:hover {
    background-color: #f2f8ff;
  }

  &.na-mode {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const ANRandCrashDonutsWrapper = styled.div`
  position: relative;
  height: 50%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const ANRandCrashDonutSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
`;

export const ANRandCrashDonutMetricSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  height: 60px;
  margin-left: 12px;

  p {
    font-weight: 500;
    margin: 0;
  }
`;
